<app-navbar *ngIf="loginService.isAuthenticatedUser()"></app-navbar>
<app-menssages></app-menssages>
<router-outlet></router-outlet>
<app-footer *ngIf="loginService.isAuthenticatedUser()"></app-footer>